import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getQueryVariable, getAllUrlParams } from './utils/urlUtils';
import { getAPIUrl, getAuthToken, getLoginPage } from './utils/authUtils';
import { GetProfile } from './utils/profileUtils';

/**
 * StoreToken hook for managing authentication tokens and navigation
 * 
 * @param {Object} config - Configuration object
 * @param {string} config.baseUrl - Base URL for API calls
 * @param {Object} config.authContext - Auth context object with isLoggedin and setisLoggedin
 * @param {Function} config.setuserDetails - Optional function to set user details in context
 * @param {Function} config.isAdmin - Optional function to check if user is admin
 * @param {Function} config.sendPosthogInfo - Optional function to send PostHog info
 * @returns {Object} Object with storeToLocal function
 */
const useStoreToken = (config) => {
  const {
    baseUrl,
    authContext,
    setuserDetails,
    isAdmin,
    sendPosthogInfo
  } = config;

  const { isLoggedin, setisLoggedin } = authContext || {};
  const navigate = useNavigate();

  // Create wrapper functions with baseUrl
  const getAPIUrlWithBase = (path) => getAPIUrl(baseUrl, path);
  const getLoginPageWithBase = (data, state) => getLoginPage(baseUrl, data, state, getAllUrlParams);
  const GetProfileWithConfig = (callback) => {
    return GetProfile(
      getAPIUrlWithBase,
      getAuthToken,
      getLoginPageWithBase,
      callback,
      setuserDetails,
      isAdmin,
      sendPosthogInfo
    );
  };

  const storeToLocal = (quot_page = false) => {
    if (quot_page && getQueryVariable("quot-key")) {
      localStorage.setItem("quot-key", getQueryVariable("quot-key"));
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("quot-key");
      navigate({ search: searchParams.toString() }, { replace: true });
      return;
    }
    if (getQueryVariable("token")) {
      localStorage.setItem("eventGraphiaToken", getQueryVariable("token"));
      localStorage.removeItem("quot-key");
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("token");
      navigate({ search: searchParams.toString() }, { replace: true });
    }
    if (localStorage.eventGraphiaToken !== undefined) {
      if (setisLoggedin) {
        setisLoggedin(true);
      }
      if (GetProfileWithConfig) {
        GetProfileWithConfig();
      }
    } else if (quot_page && localStorage.getItem("quot-key")) {
      return;
    } else {
      if (setisLoggedin) {
        setisLoggedin(false);
      }
      if (getLoginPageWithBase) {
        getLoginPageWithBase();
      }
    }
  };

  return {
    storeToLocal
  };
};

export default useStoreToken;

